import { $api } from "../generated/client";

type SizingImpactParams = {
	shopId: string;
	fromTimestamp?: number;
	toTimestamp?: number;
	productId?: string;
};

export default function useSizingImpact({
	shopId,
	...params
}: SizingImpactParams) {
	return $api.useQuery("get", "/shops/{shopId}/sizing/impact", {
		params: { path: { shopId }, query: params },
		enabled: !!shopId,
	});
}
